import { useParams } from "react-router-dom";
import { useState } from "react";

import "components/home_page/digital_info/digital_info.css";
import "./department_career_stories.css";
import DataProvider from "hoc/data_provider";
import NewsBoardLoader from "components/loader/NewsBoardLoader";
import useMetadata from "hooks/useMetadata";

const DepartmentCareerStories = () => {
    const { department } = useParams();
    const endPoint = `/web/department/career-stories/${department}`;
    return (
        <DataProvider
            endPoint={endPoint}
            department={department}
            component={CareerStoryBox}
            title="Career & Success Stories"
            icon="fas fa-briefcase"
            loader={NewsBoardLoader}
            style={{ maxWidth: "100%", minHeight: "400px", flex: "1" }}
        />
    );
};

export default DepartmentCareerStories;

const CareerStoryBox = ({ title, icon, data, ...other }) => {
    return (
        <div className="info-box column news-box career-story-box" {...other}>
            <div className="box-header row r-c-y">
                <div className="icon-title row r-c-y r-c-x">
                    <div className="header-icon">
                        <i className={icon}></i>
                    </div>
                    <h4 className="header-title">{title}</h4>
                </div>
            </div>

            <div className="info-box-content">
                {data.length > 0 ? (
                    Array.from(data, (v, i) => {
                        return <CareerStoryRow key={i} data={data[i]} />;
                    })
                ) : (
                    <p className="no-data">Career & success story details will be updated here...</p>
                )}
            </div>
        </div>
    );
};

const CareerStoryRow = ({ data }) => {
    const { proxy } = useMetadata();
    const [imgFailed, setImgFailed] = useState(false);

    let endPoint = null;
    if (data.file) {
        endPoint = `${proxy}/download/files/${data.file}`;
    }

    return (
        <div className="info-box-data column career-story-row">
            <p className="data">{data.title}</p>
            {endPoint ? (
                imgFailed ? (
                    <a
                        href={endPoint}
                        className="data career-story-file-link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View File
                    </a>
                ) : (
                    <img
                        src={endPoint}
                        alt={data.title}
                        className="career-story-media"
                        onError={() => setImgFailed(true)}
                    />
                )
            ) : null}
        </div>
    );
};
